import { lazy } from 'react';
import installationPath from 'src/constants/urlPath/erp/installationPath';
import type { RouteType } from 'src/hooks/useRouteElements';
import NewLayout from '../../layouts/NewFeatures/MainLayout';

const ProductionRequest = lazy(() => import('src/pages/ERP/ContractExecution/Production/ProductionRequest'));
const ProductionRequestForm = lazy(
  () => import('src/pages/ERP/ContractExecution/Production/ProductionRequest/Form/ProductionRequestForm')
);

const installationRoutes: RouteType[] = [
  // Installation request - Lệnh lắp đặt
  {
    path: installationPath.installationRequest,
    Layout: NewLayout,
    Component: ProductionRequest
  },
  {
    path: installationPath.installationRequestAdd,
    Layout: NewLayout,
    Component: ProductionRequestForm
  },
  {
    path: `${installationPath.installationRequestEdit}/:id`,
    Layout: NewLayout,
    Component: ProductionRequestForm
  },
  {
    path: `${installationPath.installationRequestDetail}/:id`,
    Layout: NewLayout,
    Component: ProductionRequestForm
  }
];

export default installationRoutes;
